import {
  Spacing
} from 'UI'

export default {
  paperClass: {
    flex: ({ noFlex }) => noFlex ? null : 1,
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: () => Spacing(5),
    margin: ({ margin }) => margin || 0
  },
  textSection: {
    width: '100%'
  }
}
